module.exports = __webpack_public_path__ + "img/counter-ico-1.46d60a8c.svg";